import { takeEvery, call, put } from 'redux-saga/effects';
import {
  dataRequest,
  requestFinished,
  insertUpdateItems as insertUpdateObjectCollectionItems
} from '../../../../../../common/reducers/objectCollection/reducer';

import { insertUpdateItems as insertUpdateListsCollectionItems } from '../../../../../../common/reducers/listsCollection/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksExecsService from '../../../../services/TasksExecsService';

/* import { tasksExecLogCollectionRName } from '../tasksExecLogCollection/combineRegistry';
import { tasksExecsCollectionRName } from './combineRegistry'; */

function* getTasksExecById(reducerName, action) {
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      TasksExecsService.getMyTasksExecById,
      action.payload.objectId
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status) {
        yield put(
          insertUpdateObjectCollectionItems(reducerName, {
            itemsById: result.destructData.tasksById,
            itemsIds: result.destructData.tasksIds,
            pagination: result.destructData.pagination
          })
        );
        yield put(
          insertUpdateListsCollectionItems(
            'tasksModule.collections.tasksExecLogCollection',
            {
              itemsById: result.destructData.execLogs,
              groupMapItemsIds: result.destructData.execLogsMapByExec
            }
          )
        );
        yield put(
          insertUpdateObjectCollectionItems(
            'tasksModule.collections.tasksExecsCollection',
            result.destructData.tasksById
          )
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, action.payload.objectId, status));
}

export default function createSaga(reducerName) {
  return [
    takeEvery(dataRequest(reducerName).type, getTasksExecById, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/collections/sagas/tasksExecsCollectionSaga.js